import { baseurl,token } from '../../BaseUrl'
import axios from 'axios'




export const getTablesApi = async (id) => {

    try {
        const res = await axios.get(`${baseurl}/get-tables/${id}`, {
            headers : {
                'Authorization' : `Bearer ${token}`
            }
        });
        return { isError: false, data: res.data }
    } catch (e) {
        return { isError: true, data: e.response.data.message }

    }
}